const whatsNewStore = { showWhatsNew: false };
export default whatsNewStore;
